import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import {
  Button as ButtonBootstrap,
  Card,
  FormControl,
  InputGroup,
  Modal,
} from "react-bootstrap";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../shared/styles/global.styles";
import Button from "../Button/button";
import { IoCloseSharp } from "react-icons/io5";

interface QrCodeModalProps {
  show: boolean;
  onClose: () => void;
  qrCode: string; // texto do payload
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({ show, onClose, qrCode }) => {
  const [qrCodeImg, setQrCodeImg] = useState<string>("");
  var QRCode = require("qrcode");

  useEffect(() => {
    if (qrCode) {
      QRCode.toDataURL(qrCode)
        .then((url: string) => setQrCodeImg(url))
        .catch((err: any) => console.error("Erro ao gerar QRCode", err));
    }
  }, [qrCode]);

  const copieQrCode = () => {
    navigator.clipboard.writeText(qrCode);
    Swal.fire({
      icon: "success",
      title: "Copiado com sucesso!",
      text: "O QR Code foi copiado para a área de transferência",
      allowOutsideClick: false,
    });
  };

  if (!show) return null;

  return (
    <ModalContainer show={show}>
      <ModalContent>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>QRCode</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <InputGroup className="mb-3">
            <FormControl type="text" value={qrCode} disabled />
            <ButtonBootstrap variant="outline-success" onClick={copieQrCode}>
              Copiar
            </ButtonBootstrap>
          </InputGroup>
          <Card style={{ width: "300px", margin: "auto", padding: "10px" }}>
            {qrCodeImg && (
              <Card.Img variant="top" src={qrCodeImg} alt="QRCode" />
            )}
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            schemaButton="out-danger"
            action={() => onClose()}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default QrCodeModal;
